export default __webpack_public_path__ + "static/media/section3.f3ce09e6.svg";